export function convertBytesToMB({ size, fixed = 2 }) {
	return (size / 1048576).toFixed(fixed);
}
